import { inject, Provider } from '@angular/core';
import { LocaleSettings } from '@jms/model';
import { GeneralSettingService } from '@jms/ui/ui.standalone.services/general.setting.service';
import { defineSurfaceLocale, provideSurfaceLocale } from '@workbuddy/ui/v2/surface.engine';

/** The Surface Engine locale read from the tenant's region, one definition for every app that mounts surfaces. */
export function provideTenantSurfaceLocale(): Provider {

  return provideSurfaceLocale(() => {
    const generalSettings = inject(GeneralSettingService);

    return defineSurfaceLocale(() => {
      const region = generalSettings.$generalSettings()?.region;
      const locale = region?.locale ?? LocaleSettings.locale;
      const dateFormat = region?.dateFormat ?? (locale === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy');
      const timeFormat = region?.timeFormat ?? 'HH:mm';

      return {
        timezone: region?.timezone ?? LocaleSettings.defaultTimeZone,
        dateFormat,
        timeFormat,
        dateTimeFormat: `${dateFormat} ${timeFormat}`,
        weekStartsOn: locale === 'en-US' ? 0 : 1,
        numberLocale: locale,
        currency: LocaleSettings.currencyUnit,
        currencyDisplay: 'symbol',
        durationFormat: 'short',
        locale,
      };
    });
  });
}
